import { message } from "antd";
import { MENU_CONFIG } from "./menuConfig";

export const sanitizeTabName = (path: string) => `tt_tab${path.replace(/[^a-zA-Z0-9]+/g, "_")}`;

const TAB_ALIASES: Record<string, string> = {
    "/booking": "/booking/live",
};
const SPLIT_TAB_PARENTS = ["/booking"];

export const getTabIdentity = (pathname: string): string => {
    const match = MENU_CONFIG
        .filter((m) => pathname.startsWith(m.path))
        .sort((a, b) => b.path.length - a.path.length)[0];

    if (!match) return "";
    if (!match.parentId) return TAB_ALIASES[match.path] ?? match.path;

    const parent = MENU_CONFIG.find((m) => m.id === match.parentId);
    return parent && SPLIT_TAB_PARENTS.includes(parent.path)
        ? match.path
        : parent?.path ?? match.path;
};

export const openMenuTab = (path: string) => {
    const resolvedPath = TAB_ALIASES[path] ?? path;
    const tabName = sanitizeTabName(getTabIdentity(resolvedPath) || resolvedPath);
    const win = window.open("", tabName);

    try {
        if (win && win.location.pathname === resolvedPath) {
            win.focus();
            return;
        }
        if (win && !win.closed && win.location.href !== "about:blank") {
            win.location.href = resolvedPath;
            win.focus();
            return;
        }
    } catch {

    }
    const newWin = window.open(resolvedPath, tabName);
    if (!newWin) {
        message.warning("Please allow pop-ups to open menu items in a new tab.");
    }
};
